export enum OrderNotificationTrigger {
  MADE = 'Made',
  EXPEDITED = 'Expedited',
  DRIVEN = 'Driven',
  DELIVERED = 'Delivered',
  APPROACHING = 'Approaching',
}
